import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {MessageModel} from '../messageModel';
import {DocumentSummaryConverter} from '../../../../document/common/api/converter/DocumentSummary.converter';
import {UserSummaryConverter} from '../../../../account/modules/user/api/converter/userSummary.converter';
import {MomentAdapter} from '../../../../../shared/utils/moment.utils';
import {MessageSummaryConverter} from "./messageSummary.converter";
import {
    BusinessContextSummaryConverter
} from "../../../../common/businesscontext/api/entity/converter/businessContextSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class MessageConverter extends HttpModelConverter<MessageModel> {

    constructor(private documentSummaryConverter: DocumentSummaryConverter,
                private summaryConverter: MessageSummaryConverter,
                private businessContextSummaryConverter: BusinessContextSummaryConverter) {
        super();
    }
    protected createInstance(): MessageModel {
        return new MessageModel();
    }

    protected enrichObject(result: MessageModel, src: MessageModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.documents = this.documentSummaryConverter.convertFromArray(src.documents);
        result.businessContext = this.businessContextSummaryConverter.convert(src.businessContext);
    }
}
